import { parse } from "date-and-time";
import React, { useEffect, useState } from "react";
import MainPageLeftDrawer from "./MainPageLeftDrawer";
//import NewHeader from "./NewHeader";
import axios from "axios";
import { MyUrl } from "../../App";
import { withRouter, useHistory, useLocation } from "react-router-dom";

var jwtToken = "";
function MainPage() {
  const cancelToken = axios.CancelToken;
  const source = cancelToken.source();
  //console.log(myPassword);
  //useEffect(() => {
  const items1 = localStorage.getItem("User");
  const [CheckTypeOfUser, setCheckTypeOfUser] = useState("");
  //useEffect(() => {

  // const urlParams1 = new URLSearchParams(window.location.search);
  // console.log(window.location.search.replace("?jwt=", ""));
  // const tokenFromUrl = urlParams1.get("Authorization");
  // console.log(tokenFromUrl);
  // if (tokenFromUrl != null) {
  //   sessionStorage.setItem("Token", JSON.stringify(tokenFromUrl));
  //   window.addEventListener("beforeunload", () => {
  //     sessionStorage.setItem("Token", JSON.stringify(tokenFromUrl));
  //   });
  // }

  const urlParams1 = window.location.search;
  localStorage.setItem("Token", JSON.stringify(urlParams1));
  const items2 = localStorage.getItem("Token");
  // console.log(tokenFromUrl);
  const items = localStorage.getItem("Token");
  console.log(items);

  useEffect(() => {
    const items2 = localStorage.getItem("Token");

    const getCustomersData = () => {
      axios
        .get(
          `https://dsp-api.o2rintelligence.com/api/Dashboard/GetDashboardReport?dateFrom=2024-01-16&dateTo=2024-01-16`,
          {
            headers: {
              Authorization: `Bearer ${window.location.search.replace(
                "?jwt=",
                ""
              )}`,
            },
            //cancelToken: source.token,
          }
        )
        .then((res) => {
          const data = res.data;
          // setData(data);
          console.log("data");
          console.log(data);

          // for (let i = 0; i < data.length; i++) {
          //   setChooceCompanies((prevCompanies) => [
          //     ...prevCompanies,
          //     data[i].id,
          //   ]);
          // }
        })
        .catch((error) => {})
        .finally(() => {
          //   setIsLoading(false);
        });
    };
    getCustomersData();
  }, []);

  // axios
  //   .post(
  //     `${MyUrl}/api/Account/loginWithJwt`,
  //     {},
  //     { headers: { Authorization: `${tokenFromUrl}` }, withCredentials: true }
  //   )
  //   .then((response) => {
  //     console.log(response.data);
  //   })
  //   .catch((error) => {
  //     console.log(error);
  //   });
  const timer = setTimeout(() => {
    const currentUrl = window.location.href;
    const newUrl = currentUrl.replace(
      /(\?|&)myObject=[^&]*|(\?|&)Authorization=[^&]*/gi,
      ""
    );
    window.history.replaceState({}, "", newUrl);
    console.log("This will run after 1 second!");
  }, 0);
  //return () => clearTimeout(timer);
  useEffect(() => {}, []);

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();
  console.log(width);
  return (
    <div>
      <MainPageLeftDrawer WidthFromMainPage={width} />
    </div>
  );
}
export default withRouter(MainPage);
